export default __webpack_public_path__ + "img/bg_community-2090415fa25ac326c1f2e6d436d3942d.png";